"use client";

import { cn } from "@/lib/utils";

function SkeletonBlock( { className }: { className: string } ) {
    return <div className={cn( "rounded skeleton", className )} />;
}

function TeamColumnSkeleton() {
    return (
        <div className="flex w-[96px] shrink-0 flex-col items-center gap-2">
            <SkeletonBlock className="size-[72px]" />
            <div className="flex min-h-[34px] items-start justify-center pt-1">
                <SkeletonBlock className="h-3.5 w-12" />
            </div>
        </div>
    );
}

function ScoreRowSkeleton() {
    return (
        <div className="flex w-full items-center gap-2">
            <SkeletonBlock className="size-8 shrink-0" />
            <SkeletonBlock className="h-4 w-20" />
            <SkeletonBlock className="h-5 w-10 ml-auto" />
        </div>
    );
}

function OverRowSkeleton() {
    return (
        <div className="flex h-6 items-center gap-2 overflow-hidden">
            <SkeletonBlock className="h-4 w-12 shrink-0" />
            <div className="flex flex-1 items-center gap-1">
                {Array.from( { length: 8 } ).map( ( _, index ) => (
                    <div key={index} className="size-5 shrink-0 rounded-full skeleton" />
                ) )}
            </div>
            <SkeletonBlock className="h-4 w-12 shrink-0" />
        </div>
    );
}

function TradeButtonSkeleton() {
    return <SkeletonBlock className="h-10 flex-1" />;
}

export function SpotlightCarouselSkeleton() {
    return (
        <div className="mt-4 w-full overflow-hidden rounded-xl border border-stroke bg-surface-card">
            <div className="flex flex-col gap-4 px-3 pt-3">
                <div className="flex justify-center">
                    <SkeletonBlock className="h-5 w-16" />
                </div>

                <div className="flex w-full items-center justify-between gap-2">
                    <TeamColumnSkeleton />
                    <div className="flex min-w-0 flex-1 flex-col items-center gap-3 px-1">
                        <SkeletonBlock className="h-7 w-24" />
                        <div className="flex h-2.5 w-[50px] items-center gap-0.5">
                            <SkeletonBlock className="h-full flex-1" />
                            <SkeletonBlock className="h-full flex-1" />
                        </div>
                    </div>
                    <TeamColumnSkeleton />
                </div>

                <div className="flex flex-col gap-2">
                    <ScoreRowSkeleton />
                    <ScoreRowSkeleton />
                </div>

                <div className="flex flex-col gap-3">
                    <OverRowSkeleton />
                    <div className="flex w-full gap-2">
                        <TradeButtonSkeleton />
                        <TradeButtonSkeleton />
                    </div>
                </div>
            </div>

            <div className="mt-4 mb-3 flex items-center justify-center gap-1">
                {Array.from( { length: 28 } ).map( ( _, index ) => (
                    <div
                        key={index}
                        className={cn( "size-1.5 shrink-0 rounded-full skeleton", index === 4 && "w-4" )}
                    />
                ) )}
            </div>

            <div className="flex w-full items-center justify-between border-t border-stroke px-4 py-2">
                <SkeletonBlock className="h-4 w-20" />
                <div className="size-7 rounded-full skeleton" />
            </div>
        </div>
    );
}
